import { createFileRoute } from '@tanstack/react-router'
import ContactAddresses from 'Contact/components/Contact/Sections/ContactAddresses'

export const Route = createFileRoute('/contact/$contactId/addresses')({
    component: ContactAddresses,
})
